(() => {
  const initialise = (root) => {
    if (!root || root.dataset.fgBrandDirectoryReady === 'true') return;
    root.dataset.fgBrandDirectoryReady = 'true';

    const search = root.querySelector('[data-fg-brand-search]');
    const buttons = Array.from(root.querySelectorAll('[data-fg-brand-letter]'));
    const cards = Array.from(root.querySelectorAll('[data-fg-brand-card]'));
    const count = root.querySelector('[data-fg-brand-count]');
    const empty = root.querySelector('[data-fg-brand-empty]');
    let activeLetter = 'All';

    const normalise = (value) => String(value || '')
      .trim()
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ');

    const update = () => {
      const term = normalise(search ? search.value : '');
      let visible = 0;

      cards.forEach((card) => {
        const brand = normalise(card.dataset.brand);
        const vendor = normalise(card.dataset.vendor);
        const letterMatch = activeLetter === 'All' || card.dataset.letter === activeLetter;
        const textMatch = !term || brand.includes(term) || vendor.includes(term);
        const show = letterMatch && textMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
    };

    if (search) {
      search.addEventListener('input', () => {
        if (search.value) {
          activeLetter = 'All';
          buttons.forEach((button) => {
            const active = button.dataset.fgBrandLetter === 'All';
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        }
        update();
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activeLetter = button.dataset.fgBrandLetter || 'All';
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        update();
      });
    });

    update();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-fg-brand-directory]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
